import moment from 'moment';
import { useBootstrapSelector } from '../../../redux/selectorHooks';
import { attemptFormatDate } from '../../../utils/formatting';
import { assertNotNil } from '../../../utils/types';
import {
  ITooltipContext,
  TooltipContextType,
} from '../CustomTooltip/tooltipContextInterfaces';
import { ITooltipProps } from '../hooks/tooltip/useSingleChartDataTooltip';
import * as SingleChartDataTooltipUI from '../SingleChartDataTooltip/SingleChartDataTooltipUI';
import { IAnalysisResponse } from '../../../utils/apollo/responseTypes';

interface IProps {
  query: IAnalysisResponse['query'];
  tooltipProps: ITooltipProps;
  funnelTooltipContext?: ITooltipContext;
  singleDayLabel: string;
}

const TooltipHeader = ({
  singleDayLabel,
  query,
  tooltipProps,
  funnelTooltipContext,
}: IProps) => {
  const defaultConfig = useBootstrapSelector('defaultConfig');
  assertNotNil(defaultConfig);
  const timezoneAbbr = moment().tz(defaultConfig.timezone).format('z');

  if (singleDayLabel) {
    return (
      <SingleChartDataTooltipUI.DateLabel>
        {singleDayLabel} {timezoneAbbr}
      </SingleChartDataTooltipUI.DateLabel>
    );
  }

  if (
    query.__typename === 'FunnelQuery' &&
    (funnelTooltipContext?.type === TooltipContextType.FUNNEL_TIME_TO_CONVERT ||
      funnelTooltipContext?.type === TooltipContextType.FUNNEL_FREQUENCY)
  ) {
    return (
      <SingleChartDataTooltipUI.DateLabel>
        {tooltipProps.date}
      </SingleChartDataTooltipUI.DateLabel>
    );
  }

  return (
    <SingleChartDataTooltipUI.DateLabel>
      {attemptFormatDate(tooltipProps.date)} {timezoneAbbr}
    </SingleChartDataTooltipUI.DateLabel>
  );
};

export default TooltipHeader;
